import { render } from "./AttachmentDetail.vue?vue&type=template&id=565c1139"
import script from "./AttachmentDetail.vue?vue&type=script&lang=js"
export * from "./AttachmentDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__